import { memo } from "react";

import classnames from "classnames";
import { capitalize } from "neetocist";
import { globalProps } from "neetocommons/initializers";
import { Neeto } from "neetoicons/typeface-logos";
import * as ProductTypefaceLogos from "neetoicons/typeface-logos";
import { Link } from "react-router-dom";

import { DEFAULT_HOME_PATH, SPECIAL_APP_NAMES } from "../constants";

const Header = ({ customLogo, clearSettingsNav }) => {
  const productName = globalProps.appName.substr(5);
  const normalizedName = (productName || "").trim().toLowerCase();
  const specialCase = SPECIAL_APP_NAMES[normalizedName];
  const logoName = specialCase
    ? `Neeto${specialCase}`
    : `Neeto${capitalize(normalizedName)}`;
  const ProductTypefaceLogo = ProductTypefaceLogos[logoName] ?? Neeto;
  const LogoComponent = customLogo ?? ProductTypefaceLogo;
  const isOnboarded = globalProps.user.isOnboarded !== false;

  return (
    <div className="px-4 py-3" data-testid="sidebar-info">
      <Link
        to={DEFAULT_HOME_PATH}
        className={classnames("block w-full", {
          "cursor-pointer": isOnboarded,
          "pointer-events-none": !isOnboarded,
        })}
        onClick={clearSettingsNav}
      >
        {globalProps.sidebarTitle ? (
          <span className="text-sidebar-foreground text-xl leading-9 font-bold">
            {globalProps.sidebarTitle}
          </span>
        ) : (
          <LogoComponent className="h-9 w-auto max-w-full" />
        )}
      </Link>
    </div>
  );
};

export default memo(Header);
